import { combineReducers } from 'redux';
import searchResultReducer from './search-result';

const settingsLegislativeProcesseStatusReducer = combineReducers({
  searchResult: searchResultReducer,
});

export default settingsLegislativeProcesseStatusReducer;
